// Pasek porównywarki przyklejony do dołu ekranu

import React, { FC, useState } from 'react';
import { X } from 'react-bootstrap-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

import { useCompare } from 'context/CompareContext';
import styles from 'theme/components/containers/CompareBar/CompareBar.module.scss';
import productNoImage from 'assets/images/product-no-image.png';

const VISIBLE_COUNT = 3;

const CompareProductImage: FC<{ src?: string; alt?: string }> = ({ src, alt }) => {
  const [imgError, setImgError] = useState(false);

  if (!src || imgError) {
    return <img src={productNoImage} alt={alt || ''} className={styles.image} />;
  }

  return (
    <img
      src={src}
      alt={alt || ''}
      className={styles.image}
      onError={() => setImgError(true)}
    />
  );
};

const CompareBar: FC = () => {
  const { t } = useTranslation();
  const { compareProducts, removeFromCompare, clearCompare } = useCompare();
  const navigate = useNavigate();
  const location = useLocation();

  if (compareProducts.length === 0) return null;
  if (location.pathname.includes('/compare')) return null;

  const visibleProducts = compareProducts.slice(0, VISIBLE_COUNT);
  const hiddenCount = compareProducts.length - VISIBLE_COUNT;

  return (
    <div className={styles.compareBar}>
      <div className={styles.inner}>
        <div className={styles.label}>
          <Trans>Porównaj produkty</Trans>
          <span className={styles.count}>({compareProducts.length})</span>
        </div>

        <div className={styles.products}>
          {visibleProducts.map((product) => (
            <div key={product.id} className={styles.product}>
              <CompareProductImage src={product.image} alt={product.title} />
              <span className={styles.productTitle}>{product.title}</span>
              <button
                className={styles.removeButton}
                onClick={() => removeFromCompare(product.id)}
                aria-label={t('Usuń z porównywarki')}
                type="button">
                <X />
              </button>
            </div>
          ))}

          {hiddenCount > 0 && (
            <div className={styles.hiddenMore}>
              <span>+{hiddenCount}</span>
              <Trans>więcej</Trans>
            </div>
          )}
        </div>

        <div className={styles.actions}>
          <button
            className={styles.clearButton}
            onClick={clearCompare}
            type="button">
            <Trans>Wyczyść</Trans>
          </button>
          <button
            className={styles.compareButton}
            onClick={() => navigate('/compare')}
            disabled={compareProducts.length < 2}
            type="button">
            <Trans>Porównaj</Trans>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompareBar;